
import { BlogCard } from "./BlogCard";
import { Button } from "@/components/ui/button";
import { ArrowRight, Loader2, BookOpen } from "lucide-react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { useBlogPosts } from "@/hooks/blog";
import { useEffect } from "react";

export function BlogSection() {
  // Fetch blog posts from server with caching enabled
  const { posts, loading, error } = useBlogPosts({ 
    initialPage: 1,
    initialPerPage: 3
  });
  
  // Animation variants
  const container = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };
  
  useEffect(() => {
    if (error) {
      console.error("Error loading blog posts for home page:", error);
    }
  }, [error]);
  
  return (
    <div className="py-12">
      <div className="mb-8">
        <div className="text-left">
          <h2 className="text-3xl font-bold metal-text tracking-tight mb-2 relative inline-block">
            Dal Blog
            <div className="absolute -bottom-1 left-0 w-1/3 h-1 bg-gold"></div>
          </h2>
          <p className="text-foreground/80 max-w-2xl">
            Articoli, guide e approfondimenti sul mondo dei metalli preziosi
          </p>
        </div>
        
        <div className="flex justify-end mt-4">
          <Link to="/blog">
            <Button variant="outline" className="border-metal-light text-[color:hsl(var(--metal-primary))] hidden md:flex items-center gap-2 group hover:bg-metal-light/10">
              Vedi tutti gli articoli
              <ArrowRight className="h-4 w-4 group-hover:translate-x-1 transition-transform" />
            </Button>
          </Link>
        </div>
      </div>
      
      {loading ? (
        <div className="flex justify-center py-12">
          <Loader2 className="h-8 w-8 animate-spin text-gold" />
        </div>
      ) : (
        <motion.div 
          className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8"
          variants={container}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true }}
        >
          {posts.length > 0 ? (
            posts.map(post => (
              <BlogCard key={post.id} post={post} />
            ))
          ) : (
            <div className="col-span-3 flex flex-col items-center justify-center py-12 text-center">
              <div className="rounded-full bg-muted p-3 mb-4">
                <BookOpen className="h-6 w-6 text-muted-foreground" />
              </div>
              <h3 className="text-xl font-semibold mb-2">Contenuti in arrivo</h3>
              <p className="text-muted-foreground max-w-lg">
                Gli articoli del blog saranno presto disponibili. Stiamo lavorando per offrirti contenuti di qualità sul mondo dell'oro e dei metalli preziosi.
              </p>
            </div>
          )}
        </motion.div>
      )}
      
      <div className="flex justify-center md:hidden">
        <Link to="/blog">
          <Button className="bg-[color:hsl(var(--metal-primary))] text-white items-center gap-2 group hover:bg-[color:hsl(var(--metal-primary))]/90">
            Vedi tutti gli articoli
            <ArrowRight className="h-4 w-4 group-hover:translate-x-1 transition-transform" />
          </Button>
        </Link>
      </div>
    </div>
  );
}
